<template>
  <div class="profile-block__tab-nav tab-nav">
    <div class="tab-nav__item" :class="{active: routeName.indexOf('profile') !== -1}">
      <router-link :to="{name: 'profile'}">ПРОФИЛЬ</router-link>
    </div>
    <div class="tab-nav__item" :class="{active: routeName.indexOf('delivery-address') !== -1}">
      <router-link :to="{name: 'delivery-address'}">АДРЕСА</router-link>
    </div>
    <div class="tab-nav__item" :class="{active: routeName.indexOf('order-history') !== -1}">
      <router-link :to="{name: 'order-history'}">ИСТОРИЯ ЗАКАЗОВ</router-link>
    </div>
    <div class="tab-nav__item">
      <a href="/favorites/" target="_blank">ИЗБРАННОЕ</a>
    </div>
  </div>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        name: 'ProfileTabs',
        components: {
        },
        computed: {
          routeName() { return this.$route.name; }
        },
        watch: {

        },
        methods: {
          ...mapActions('StorePersonal', ['setStep'])
        },
        mounted() {

        }
    }
</script>